import React from "react";
import FullScreenLoader from "../../components/fullScreenLoader/fullScreenLoader";
import TestQues from "../../components/testQues/testQues";
import { AnswerContext } from "../../store/answerStore";
import TestFooterAudio from "../testFooterAudio/testFooterAudio";
import "./listenSpeakPara.scss";

export default function ListenSpeakPara({ question, questions, index }) {
  const { answerC, dispatchAnswer } = AnswerContext();
  const { isLoading } = answerC;
  return (
    <>
      {isLoading ? (
        <FullScreenLoader msg="Please wait your audio is processing" />
      ) : (
        <>
          <div data-aos="zoom-in" className="test-body-content">
            <TestQues type="listenSpeak" question={question} />
          </div>

          <TestFooterAudio
            question={question}
            questions={questions}
            index={index}
          />
        </>
      )}
    </>
  );
}
